import splitRow from './splitRow'

export default function splitTitleV2(className = 'anime-text') {
    splitRow(className, 'js-row-title')
    const arrContent = document.querySelectorAll(`.${className} .js-row-title`)

    if (arrContent) {
        for (const row of arrContent) {
            let title = row.innerHTML

            if (title) {
                const tagsSkip = ['<br />', '<br/>', '<br>', '<sup>', '</sup>', '<sub>', '</sub>', '<b>', '</b>']

                for (const tag of tagsSkip) {
                    title = title.split(tag).join(` ${tag} `)
                }

                const div = document.createElement('div')
                div.innerHTML = title

                title = div.innerHTML
                    .split(' ')
                    .map((e, i) => {
                        const tagFind = tagsSkip.find((tag) => tag === e)

                        if (tagFind) {
                            return e
                        } else {
                            return e.replace(/\S/g, "<span class='letter js-title-letter'>$&</span>")
                        }
                    })
                    .join(' ')

                for (const tag of tagsSkip) {
                    title = title.split(` ${tag}`).join(tag)
                    title = title.split(`${tag} `).join(tag)
                }
            }

            row.innerHTML = title
        }
    }
}
